'use client';

import { useEffect } from 'react';
import useClientStore from '@/store/useClientStore';
import useVehiclesStore from '@/store/useVehiclesStore';
import { ordenDelTenant } from '@/lib/orden-vehiculos';

/**
 * Garantiza que el inventario del tenant esté cargado (o cargándose) en
 * `useVehiclesStore`, y lo devuelve.
 *
 * Lo llama todo componente que lee el store. Normalmente es un no-op: el
 * `ClientProvider` ya disparó la carga al resolver el tenant. Hace falta para
 * los casos en que no lo hizo —la carga arranca en la ficha de un vehículo,
 * que no usa el inventario, y después se navega al listado dentro de la misma
 * sesión— porque el efecto del provider corre una sola vez, al montar.
 *
 * La carga se dedupe en el store: por más consumidores que la pidan a la vez,
 * el inventario se baja una sola vez por visita.
 */
export function useEnsureVehicles() {
  const { client } = useClientStore();
  const store = useVehiclesStore();
  const clientId = client?.id;
  const hasDemo = !!(client as { has_demo?: boolean } | null)?.has_demo;
  // Ticket #164: orden inicial configurado por la automotora.
  const orden = ordenDelTenant((client as Record<string, unknown> | null)?.web_vehicle_order);

  useEffect(() => {
    if (clientId == null || clientId === '') return;
    void store.ensureVehicles(clientId, hasDemo, orden);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, hasDemo, orden]);

  return store;
}

export default useEnsureVehicles;
